import { createApp, toRaw } from "vue"
import HorizontalLinks from "../components/HorizontalLinks.vue"
import ActionSheet from "../components/ActionSheet.vue"
import SelectSearchable from "../components/SelectSearchable.vue"
import ClickOutside from "../directives/ClickOutside"
import { Locations } from "../services/locations"
import ShowCompaniesWrapper from "../components/Companies/ShowCompaniesWrapper.vue"
import BudgetModal from "../components/BudgetModal"
import { Modal } from "bootstrap"

import { Swiper, SwiperSlide } from "swiper/vue"
import { Scrollbar, Pagination } from "swiper"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/scrollbar"
import VueMask from '@devindex/vue-mask'

const locations = new Locations()

const app = createApp({
    components: {
        ActionSheet,
        HorizontalLinks,
        SelectSearchable,
        ShowCompaniesWrapper,
        Swiper,
        SwiperSlide,
        BudgetModal,
        Modal
    },
    data() {
        return {
            showFilters: false,
            budget: false,
            form: {
                cidade: window.parameters.cidade || "",
                bairro: window.parameters.bairro || "",
                facilidades: [],
                funcionamento: [],
                uf: window.locations?.current || "rn",
                ...(window.query || {}),
            },
            cidades: [],
            bairros: [],
            servicos: window.servicos || [],
            featuredBreakpoints: {
                0: {
                    slidesPerView: 1,
                },
                992: {
                    slidesPerView: 2,
                },
            },
            featuredCompaniesBreakpoints: {
                0: {
                    slidesPerView: 1,
                    enabled: false,
                },
                768: {
                    enabled: true,
                    slidesPerView: 1,
                },
                900: {
                    slidesPerView: 2,
                },
            },
            mapa: {
                nome: null,
                latitude: null,
                longitude: null,
                referencia: null,
                endereco: null
            },
            Pagination,
            Scrollbar,
        }
    },
    methods: {
        loadCidades() {
            this.cidades = [
                {
                    slug: "",
                    nome: "Cidade",
                },
            ]
            locations.cidades({ uf: this.form.uf }).then((response) => {
                this.cidades.push(...response.data)
            })
        },
        loadBairros() {
            this.bairros = [
                {
                    slug: "",
                    nome: "Bairro",
                },
            ]
            if (!this.form.cidade) return
            locations.bairros({ cidade: this.form.cidade }).then((response) => {
                this.bairros.push(...response.data)
            })
        },
        openMaps(empresa) {
            this.mapa = empresa

            const modal = new Modal(document.getElementById("mapsModal"))
            modal.show()
        },
        clearFilters() {
            this.form = {
                cidade: "",
                bairro: "",
                facilidades: [],
                funcionamento: [],
                uf: this.form.uf,
            }
        }
    },
    created() {
        this.loadCidades()
        this.loadBairros()
    },
    computed: {
        countFilters() {
            const form = this.form;
            const fieldsToIgnore = ['seed', 'subcategory'];
            
            const arrayLength = (form.facilidades?.length || 0) + (form.funcionamento?.length || 0);
            const normalFields = Object.entries(form)
                .filter(([key, value]) => !fieldsToIgnore.includes(key) && !Array.isArray(value) && !!value)
                .length;
            
            return arrayLength + normalFields;
        },
        getFilterUrl() {
            let baseUrl = window.routes["current"]
                .replace(window.location.origin, '')
                .replace("__uf", this.form.uf)
                .replace("__segmento", window.parameters?.segmento)
                .replace("__slug", window.parameters?.slug)
                .replace(/\?/g, '');

            const url = [baseUrl];

            if (this.form.cidade) {
                if (window.parameters.cidade) {
                    url[0] = url[0].replace("__cidade", this.form.cidade)
                } else {
                    url.push(this.form.cidade)
                }
            }

            if (this.form.cidade && this.form.bairro) {
                if (window.parameters.bairro) {
                    url[0] = url[0].replace("__bairro", this.form.bairro)
                } else {
                    url.push(this.form.bairro)
                }
            }

            return url
                .filter(String)
                .join("/")
                .replace(/\/+/g, '/')
                .replace(/\?/g, '');
        },
    },
    watch: {
        "form.cidade": {
            deep: true,
            handler() {
                this.loadBairros()
            },
        },
        "form.uf": {
            deep: true,
            handler() {
                this.loadCidades()
            },
        },
    },
})
app.directive("click-outside", ClickOutside)
app.use(VueMask)
app.mount("#companies")
